import { Box, Popover, styled } from '@mui/material'
import navMenu from 'assets/images/mobile/navMenu.png'
import navMenuCloseIcon from 'assets/images/mobile/menuClose.png'
import { useGames } from 'state/games/hooks'
import { useLocation } from 'react-router-dom'
import { ApplicationModal } from 'state/application/reducer'
import { useAppDispatch } from 'state'
import { useMessageInfo, useUser } from 'state/user/hooks'
import { logoutThunk } from 'state/user/actions'
import { Menu, menus } from 'utils/userMenu'
import Logo from 'assets/images/svg/common/logo.svg'
import { useModalOpen, useToggleModal } from 'state/application/hooks'

import SmileyPic from 'assets/images/svg/smiley.svg'
import { useState, useMemo } from 'react'

const HeaderMobileStyled = styled(Box)`
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 60px;
  background: #171717;
  height: 56px;
  width: 100%;
  display: none;
  font-size: 16px;
  .signInText {
    text-align: right;
    font-weight: 500;
  }
  .userIcon {
    width: 40px;
    height: 40px;
  }
  .smCtt {
    height: 100%;
    margin: 0 auto;
    padding: 0 16px;
    .logo {
      position: absolute;
      width: 88px;
      height: 24px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10000000;
    }
  }
  .dmr16 {
    margin-right: 16px;
  }
  .flexRowStartCenter {
    display: flex;
    justify-content: start;
    align-items: center;
  }
  ul {
    list-style: none;
  }
  .smCtt {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

const MenuMobileStyled = styled(Box)`
  width: 100vw;
  background: #171717;
  color: #fff;
  .navItemList {
    width: 100%;
    font-weight: 500;
    .loginOut {
      font-weight: 500;
      text-align: left;
    }
  }
  > input {
    display: none;
  }
  .pdlr20 {
    padding: 0 24px;
  }
  > input:checked + .navItemList {
    left: 0;
    z-index: 100;
    > li {
      overflow: hidden;
      line-height: 72px;
      background: #171717;
      .tab-label {
        display: flex;
        justify-content: space-between;
        padding: 0 24px;
      }
      .tab-label::after {
        content: '❯';
        width: 16px;
        text-align: center;
        transition: all 0.35s;
      }
      .tab-content {
        max-height: 0;
        transition: all 0.35s;
      }
      #navGames {
        display: none;
      }
      #navGames:checked ~ .tab-content {
        max-height: 100vh;
      }
      #navGames:checked + .tab-label::after {
        transform: rotate(90deg);
      }
    }
    .gamesView {
      .ctt {
        padding: 0 30px;
      }
    }
  }
  > img {
    width: 24px;
    height: 24px;
  }
`

const NavRightMobileStyled = styled(Box)`
  text-align: right;
  width: 100vw;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  .userIcon {
    width: 44px;
    height: 44px;
    margin-right: 16px;
  }
  .navItemList {
    width: 100%;
    .flexRowStartCenter {
      display: flex;
      align-items: center;
    }
    li {
      padding: 20px 0;
      margin-left: 24px;
      font-weight: 600;
      font-size: 16px;
      text-align: left;
      border-bottom: 1px solid #323232;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      span {
        width: 20px;
        height: 20px;
        background: ${props => props.theme.colors.red[100]};
        border-radius: 50%;
        margin-left: 8px;
        font-weight: 600;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${props => props.theme.colors.white};
      }
      ::marker {
        display: none;
        visibility: hidden;
        color: transparent;
      }
    }
  }
  #userInfoIpt:checked + .navItemList {
    display: block;
    position: absolute;
    left: 0;
    z-index: 100;
    > li {
      overflow: hidden;
      line-height: 72px;
      background: #171717;
      text-align: left;
    }
  }
`
const GamesCellStyle: any = styled(Box)`
  background: url(${(props: any) => props.cover || ''});
  background-size: cover;
  background-position-y: -25px;
  .ctt {
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    padding: 0 3px;
  }
`
export interface IGamesCell {
  // appointmentStatus: null
  cover: string
  description: string
  id: string
  gameAlias: string
  linkUrl: string
  // publishTime: null
  // publisher: null
  // tags: null
  title: string
}

export default function HeaderMobile({ classNameString }: { classNameString?: string }) {
  const message = useMessageInfo()
  const checkedMenu = useModalOpen(ApplicationModal.MOBILE_MENU)
  const checkedUser = useModalOpen(ApplicationModal.MOBILE_USER_MENU)
  const toggleModal = useToggleModal(ApplicationModal.MOBILE_MENU)
  const toggleUserModal = useToggleModal(ApplicationModal.MOBILE_USER_MENU)
  const location = useLocation()
  const { games } = useGames()
  const dispatch = useAppDispatch()
  const user = useUser()
  const [anchorEl, setAnchorEl] = useState<any>(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    if (checkedMenu) {
      toggleModal()
    } else if (checkedUser) {
      toggleUserModal()
    }
    setAnchorEl(null)
  }

  const id = checkedMenu ? 'simple-popover' : undefined
  const checkHidden = useMemo(() => {
    const hiddenPagePathList = ['game/OathofPeak/earlyaccess']
    const mapHiddenList = hiddenPagePathList.some(path => location.pathname.indexOf(path) > -1)
    return !mapHiddenList
  }, [location.pathname])
  if (!checkHidden) {
    return null
  }
  return (
    <HeaderMobileStyled className={classNameString}>
      <div className="smCtt">
        {!checkedMenu && (
          <img
            width={24}
            aria-describedby={id}
            src={navMenu}
            alt=""
            onClick={event => {
              handleClick(event)
              toggleModal()
            }}
          />
        )}
        {checkedMenu && (
          <img
            width={24}
            aria-describedby={id}
            className="menuClose"
            src={navMenuCloseIcon}
            alt=""
            onClick={() => {
              handleClose()
            }}
          />
        )}
        {location.pathname.indexOf('/game/') === -1 && <img src={Logo} className="logo" alt="" />}
        {!user && (
          <span
            className="signInText"
            onClick={() => {
              window.location.href = `/login?redirectUrl=${encodeURIComponent(window.location.href)}`
            }}
          >
            Log In
          </span>
        )}
        {user && (
          <img
            className="userIcon"
            src={user.headIcon || SmileyPic}
            alt=""
            onClick={event => {
              if (checkedUser) {
                setAnchorEl(null)
              } else {
                setAnchorEl(event.currentTarget)
              }
              toggleUserModal()
            }}
          />
        )}
      </div>
      <Popover
        id={id}
        open={checkedMenu || checkedUser}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="mobile-header-popover"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {checkedMenu && (
          <MenuMobileStyled>
            <input id="menuMobile" type="checkbox" checked={checkedMenu} onChange={() => console.log(checkedMenu)} />
            <ul className="navItemList">
              <li
                className="pdlr20"
                onClick={() => {
                  toggleModal()
                  window.location.href = '/'
                }}
              >
                Home
              </li>
              <li className="gamesView">
                <input type="checkbox" id="navGames" />
                <label className="tab-label pdlr20" htmlFor="navGames">
                  Games
                </label>
                <div className="tab-content">
                  <ul>
                    {games?.length > 0 &&
                      games.map((item: IGamesCell, index: number) => (
                        <GamesCellStyle
                          key={index}
                          cover={item.cover}
                          onClick={() => {
                            toggleModal()
                            window.location.href = `/game/${item.gameAlias}`
                          }}
                        >
                          <div className="ctt">{item.title}</div>
                        </GamesCellStyle>
                      ))}
                  </ul>
                </div>
              </li>
              <li
                className="pdlr20"
                onClick={() => {
                  toggleModal()
                  window.location.href = `/nft`
                }}
              >
                Market
              </li>
              <li
                className="pdlr20"
                onClick={() => {
                  toggleModal()
                  window.location.href = `/mint`
                }}
              >
                Mint
              </li>
              <li
                className="pdlr20"
                onClick={() => {
                  toggleModal()
                  window.location.href = '/community'
                }}
              >
                Community
              </li>
            </ul>
          </MenuMobileStyled>
        )}
        {checkedUser && (
          <NavRightMobileStyled>
            {user && (
              <ul className="navItemList">
                {/* <li className="pdlr20 flexRowStartCenter">
                  <img className="userIcon dmr16" src={user.headIcon || SmileyPic} alt="" />
                  <span>{user?.nickName || ''}</span>
                </li> */}
                {menus?.length > 0 &&
                  menus.map((item: Menu, index: number) => (
                    <>
                      <li
                        key={index}
                        className="pdlr20"
                        onClick={() => {
                          toggleUserModal()
                          if (item.link) {
                            if (item.text === 'Profile') {
                              window.location.href = `/u/${user.uid}`
                            } else {
                              if (item?.link) {
                                window.location.href = item.link
                              }
                            }
                          }
                          if (item.text === 'Log Out') {
                            dispatch(logoutThunk())
                          }
                        }}
                      >
                        {item?.text}
                        {item?.text === 'My Inbox' && message && message.unreadNum > 0 && (
                          <span>{message.unreadNum}</span>
                        )}
                      </li>
                    </>
                  ))}
                {/* <li className="pdlr20 loginOut" onClick={() => dispatch(logoutThunk())}>
                  Log Out
                </li> */}
              </ul>
            )}
          </NavRightMobileStyled>
        )}
      </Popover>
    </HeaderMobileStyled>
  )
}
